// extracted by mini-css-extract-plugin
export default {"container":"SettingsModal_container__XlZfZ"};